export default "__VITE_ASSET__$niMX0On__"